import type { Pregunta, RespuestaAdmin } from '../../api/tipos';
import { Avatar } from '../../componentes/Avatar';
import { textoDeValor } from './exportarRespuestas';

interface Props {
  preguntas: Pregunta[];
  respuestas: RespuestaAdmin[];
}

export function TablaRespuestas({ preguntas, respuestas }: Props) {
  if (respuestas.length === 0) {
    return <p className="text-[12.5px] text-mudo">Todavía nadie respondió este evento.</p>;
  }

  return (
    <div className="overflow-x-auto rounded-xl border border-white/[.09]">
      <table className="w-full min-w-[520px] border-collapse text-left text-[13px]">
        <thead>
          <tr className="bg-white/[.04] text-[11px] uppercase tracking-[1.1px] text-debil">
            <th className="px-3.5 py-2.5 font-semibold">Colaborador</th>
            <th className="px-3.5 py-2.5 font-semibold">¿Asiste?</th>
            {preguntas.map((pregunta) => (
              <th key={pregunta.id} className="min-w-[140px] px-3.5 py-2.5 font-semibold">
                {pregunta.etiqueta}
                {pregunta.privada && (
                  <span className="ml-1.5 normal-case tracking-normal text-cian">(privada)</span>
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {respuestas.map((respuesta) => (
            <tr key={respuesta.usuario.id} className="border-t border-white/[.07] align-top">
              <td className="px-3.5 py-2.5">
                <div className="flex items-center gap-2.5">
                  <Avatar usuarioId={respuesta.usuario.id} nombre={respuesta.usuario.nombre} tamano={28} />
                  <div className="min-w-0">
                    <div className="truncate font-semibold">{respuesta.usuario.nombre}</div>
                    <div className="truncate text-[11.5px] text-debil">{respuesta.usuario.email}</div>
                  </div>
                </div>
              </td>
              <td className="px-3.5 py-2.5">
                <span
                  className={`inline-block rounded-full border px-2.5 py-[3px] text-[11px] font-semibold ${
                    respuesta.asiste
                      ? 'border-lima/40 bg-lima/10 text-lima'
                      : 'border-tenue/30 bg-tenue/[.07] text-tenue'
                  }`}
                >
                  {respuesta.asiste ? 'Sí, va' : 'No va'}
                </span>
              </td>
              {preguntas.map((pregunta) => {
                const texto = textoDeValor(
                  pregunta,
                  respuesta.valores.find((valor) => valor.preguntaId === pregunta.id),
                );
                return (
                  <td key={pregunta.id} className="whitespace-pre-line px-3.5 py-2.5 text-cuerpo">
                    {texto ?? <span className="text-mudo">—</span>}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
